import { useState, useEffect } from 'react';
import generalController from '../controllers/generalController';

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | null;

export const useMediaQuery = (): Breakpoint => {
  const [mediaQuery, setMediaQuery] = useState<Breakpoint>(generalController.getMediaQuery());

  useEffect(() => {
    // timeoutId for debounce mechanism
    let timeoutId: NodeJS.Timeout | null = null;

    const handleWindowResize = () => {
      // Prevent execution of previous setTimeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // Run after 150 milliseconds.
      timeoutId = setTimeout(() => {
        setMediaQuery(generalController.getMediaQuery());
      }, 150);
    };

    // Set resize listener
    window.addEventListener("resize", handleWindowResize);
    // Remove resize listener
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  // Return the current breakpoint
  return mediaQuery;
};
